import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({},'div',attrs,false),on),[_c(VSwitch,{attrs:{"dense":_vm.dense,"color":_vm.color,"hide-details":"","prepend-icon":_vm.showIcon ? _vm.icon : null,"label":_vm.showLabel ? _vm.getLabel : null},model:{value:(_vm.dark),callback:function ($$v) {_vm.dark=$$v},expression:"dark"}})],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.getLabel))])])}
var staticRenderFns = []

export { render, staticRenderFns }